export const UserStatus = {
    INCOMPLETE: 'incomplete',
    PENDING: 'pending',
    ONHOLD: 'onhold',
    APPROVED: 'approved',
  };
  